function n({
  array: t,
  oldIndex: r,
  newIndex: l
}) {
  const e = [...t];
  if (l >= e.length) {
    let i = l - e.length + 1;
    for (; i--; )
      e.push(void 0);
  }
  return e.splice(l, 0, e.splice(r, 1)[0]), e;
}
export {
  n as default
};
